import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { useNavigate } from "react-router-dom";
import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import Inventory2Icon from '@mui/icons-material/Inventory2';
import { labelStore } from "../../../FrontEnd/UpdateChange/LableStore";
import { useDispatch } from "react-redux";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";
import { resetDataComponent } from "../../../StateManagement/actions";


export const UnitList: React.FC = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();
  
  const [selectedId, setSelectedId] = useState<string | number>(0);
  const [isPopupOpen, setPopupOpen] = useState(false);

  useEffect(() => {
  updateMainHeader("Inventory");
  labelStore.updateIcon(<Inventory2Icon sx={{ fontSize: 32 }} />);
}, []);


  // Breadcrumbs
  breadCrumbsStore.updateBreadCrumbs([
    { "Unit Management": "/units/list" },
  ]);

 const source = {
    url: "units/list",  // ✅ Fixed API path
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
    type: 'GET' as const 
  };

 
  const columns: IColumns[] = [
    { header: "Unit Name", fieldName: "UnitName" },
    { header: "Symbol", fieldName: "Symbol", tooltip: true },
     {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete"],
      actionCallback: (action: string, row: any) => {


        const unitId = row.UnitId ;
        if (!unitId) {
          console.error("❌ No valid ID found in row:", row);
          showMessage("Invalid warehouse data - missing ID", "error");
          return;
        }
        
        if (action === "Edit") {
          navigate(`/unit/${unitId}`);
        } else if (action === "Delete") {
          setSelectedId(unitId);
          setPopupOpen(true);
        }
      },
    },
   
  ];

  // Filters (UI only)
 

  const handleClick = () => {
    navigate("/unit");
  };

  return (
    <Grid p={3}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGrid
            id="unitGrid"
            title="Unit Management"
            headerType="modern"
            columns={columns}
            source={source}
            rowsPerPageCount={10}
            searchBox={{ searchMode: "query" }}
            addButton={{ label: "Add New unit", color: "secondary" }}
            onAddButtonClick={handleClick}
            
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
        </Grid>
      </Grid>
      <ConfirmationPopup
          type="DELETE"
          apiUrl="units"  
          id={selectedId}
          confirmMessage="Are you sure you want to delete this Unit?"
          open={isPopupOpen}
          onClose={() => setPopupOpen(false)}
          onConfirm={(data: any) => {
            dispatch(resetDataComponent("unitGrid"));
            if (data.success === true) {
              showMessage(data?.message, "success");
            } else {
              showMessage(data?.detail, "error");
            }
          }}
        />
    </Grid>
  );
};